import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import ContactsModal from '../../components/Modals/ContactsModal/ContactsModal'
import GenericOTPModal from '../../components/Modals/GenericOTPModal/GenericOTPModal'
import OTPModal from '../../components/Modals/PwdMgmtModals/OTPModal/OTPModal'
import PasswordModal from '../../components/Modals/PwdMgmtModals/PasswordModal/PasswordModal'
import SecurityQuestionsModal from '../../components/Modals/PwdMgmtModals/SecurityQuestionsModal/SecurityQuestionsModal'
import SecurityMethodsModal from '../../components/Modals/SecurityMethodsModal/SecurityMethodsModal'
import { OtpOperationType, ContactsType } from './module/constants'
import { generateUigpOtpAction, verifyUigpOtpAction } from './module/actions'
import {
  selectAuthResponseError,
  selectCallState,
  selectUigpOtpReceiver,
} from './module/selectors'
import { responseOtpSelector } from '../../pages/Login/module/selectors'
import ResponseModal from '../../components/Modals/ResponseModal/ResponseModal'
import { IResponseState } from '../../components/Modals/ResponseModal/module/constants'
import { FormattedMessage } from 'react-intl'
import messages from './module/messages'
import { createStructuredSelector } from 'reselect'
import SecurityQuestionsUpdatePwdModal from '../../components/Modals/PwdMgmtModals/UpdatePwdModals/SecurityQuestionsModal/SecurityQuestionsUpdatePwdModal'
import { MfaOperationType } from '../../components/Modals/PwdMgmtModals/UpdatePwdModals/module/constants'
import { IDataPostLogin } from '../../pages/Login/module/constants'
import { IGrantType } from '../../components/Modals/PwdMgmtModals/OTPModal/module/constants'
import { LOGIN_CLIENT_ID } from '../../module/constants'
import {
  postOTPAction,
  setFirstAccessAction,
  setOldPasswordAction,
} from '../../pages/Login/module/actions'
import CustomModal from '../../components/Modals/CustomModal/CustomModal'
import { selectSmsEnabled } from '../../store/global/selectors'

interface TwoFactorAuthProps {
  callState: IResponseState
  uigpOtpReceiver: string
  smsEnabled: boolean
  generateUigpOTP: (body: {
    operation: OtpOperationType
    method: ContactsType
    userCode?: string
  }) => void
  verifyUigpOTP: (body: {
    operation: OtpOperationType
    otp: string
    userCode?: string
  }) => void
  isLogin?: boolean
  operation: OtpOperationType
  showMfa?: boolean
  showUigp?: boolean
  showSec?: boolean
  responseError: string
  onClose: () => void
  onCloseResponseModal: () => void
  confirmOperation: (
    mehtods: 'mfaRequired' | 'securityQuestionsRequired' | 'uigpOTPRequired',
    extra: any
  ) => void
  postOtp: (body: IDataPostLogin) => void
  otpResponseState: IResponseState
  firstAccess?: boolean
  setFirstAccess: (isFirst: boolean) => void
  setOldPassword: (pwd: string | null) => void
}

function TwoFactorAuth({
  isLogin = false,
  showMfa = false,
  showSec = false,
  showUigp = false,
  operation,
  callState,
  uigpOtpReceiver,
  onClose,
  generateUigpOTP,
  verifyUigpOTP,
  onCloseResponseModal,
  confirmOperation,
  postOtp,
  otpResponseState,
  smsEnabled,
  firstAccess = false,
  setFirstAccess,
  setOldPassword,
  responseError,
}: TwoFactorAuthProps) {
  const [userCode, setUserCode] = useState<string>('')
  const [showMethodsModals, setShowMethodsModal] = useState(false)
  const [showCustomModal, setShowCustomModal] = useState(false)

  const [showMfaModal, setShowMfaModal] = useState<boolean>(false)
  const [showSecQuestModal, setShowSecQuestModal] = useState<boolean>(false)
  const [showUigpOtpModal, setShowUigpOtpModal] = useState<boolean>(false)
  const [showContactModal, setShowContactModal] = useState<boolean>(false)

  const [showResponseModal, setShowResponseModal] = useState<boolean>(false)
  const [showUigpOtpResponseModal, setShowUigpOtpResponseModal] =
    useState<boolean>(false)

  const [showPasswordModal, setShowPasswordModal] = useState<boolean>(false)

  const [receiver, setReceiver] = useState<string>('')

  useEffect(() => {
    if (isLogin) {
      setShowPasswordModal(false)
      if (firstAccess) {
        setShowPasswordModal(true)
      } else {
        setShowMethodsModal(true)
      }
    } else {
      setShowMethodsModal(true)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (uigpOtpReceiver) setReceiver(uigpOtpReceiver)
  }, [uigpOtpReceiver])

  useEffect(() => {
    if (otpResponseState === IResponseState.SUCCESS) {
      secAuthSuccessHandler()
    } else if (otpResponseState === IResponseState.ERROR) {
      setShowCustomModal(true)
    } else {
      setShowCustomModal(false)
    }
  }, [otpResponseState])

  useEffect(() => {
    if (showMfaModal || showSecQuestModal || showContactModal) {
      setShowMethodsModal(false)
    }
  }, [showMfaModal, showSecQuestModal, showContactModal])

  const chooseMethodHandler = (
    method: 'mfaRequired' | 'securityQuestionsRequired' | 'uigpOTPRequired'
  ) => {
    switch (method) {
      case 'mfaRequired':
        setShowMfaModal(true)
        break
      case 'securityQuestionsRequired':
        setShowSecQuestModal(true)
        break
      case 'uigpOTPRequired':
        setShowContactModal(true)
        break
      default:
    }
  }

  const secAuthSuccessHandler = () => {
    setShowPasswordModal(true)
  }

  const contactSelectHandler = (method: ContactsType, userCode?: string) => {
    if (userCode) setUserCode(userCode)
    setShowContactModal(false)
    setShowUigpOtpResponseModal(true)
    generateUigpOTP({
      operation: operation,
      method,
      userCode,
    })
  }

  const closeResponseModalHandler = () => {
    setShowResponseModal(false)
    setShowMethodsModal(false)
    onCloseResponseModal()
  }

  const closeUigpOtpResponseModalHandler = () => {
    if (receiver !== '') {
      setShowUigpOtpModal(true)
    } else {
      setShowMethodsModal(true)
    }
    setShowUigpOtpResponseModal(false)
  }

  const confirmUigpOtp = (otp: string) => {
    if (isLogin) {
      let body = {} as IDataPostLogin
      body = {
        grant_type: IGrantType.UIGP_OTP,
        username: userCode,
        password: otp,
        client_id: LOGIN_CLIENT_ID, //??
      }
      var formBody: any = []
      Object.keys(body).forEach((key) => {
        let encodedKey = encodeURIComponent(key)
        // @ts-ignore // ToDo -> fix types
        let encodedValue = encodeURIComponent(body[key])
        formBody.push(encodedKey + '=' + encodedValue)
      })
      formBody = formBody.join('&')

      postOtp(formBody)
    } else {
      confirmOperation('uigpOTPRequired', otp)
    }
  }

  const closeLoginSecQuestModalHandler = () => {
    setShowSecQuestModal(false)
    if (showSec && !showMfa && !showUigp) {
      onClose()
      return
    } else {
      setShowMethodsModal(true)
    }
  }

  const closeSecQuestModalHandler = () => {
    setShowSecQuestModal(false)
    if (showSec && !showMfa && !showUigp) {
      onClose()
      return
    } else {
      setShowMethodsModal(true)
    }
  }

  const closeMfaModalHandler = () => {
    setShowMfaModal(false)
    if (showMfa && !showSec && !showUigp) {
      onClose()
      return
    } else {
      setShowMethodsModal(true)
    }
  }

  const closeContactModalHandler = () => {
    setShowContactModal(false)
    if (showUigp && !showMfa && !showSec) {
      onClose()
      return
    } else {
      setShowMethodsModal(true)
    }
  }

  const closeUigpOtpModalHandler = () => {
    setShowUigpOtpModal(false)
    if (showUigp && !showSec && !showMfa) {
      onClose()
      return
    } else {
      setShowMethodsModal(true)
    }
  }

  return (
    <>
      {/* RESPONSE MODALS */}
      <ResponseModal
        show={showResponseModal}
        state={callState}
        onClose={closeResponseModalHandler}
      />
      <ResponseModal
        show={showUigpOtpResponseModal}
        state={callState}
        onClose={closeUigpOtpResponseModalHandler}
        customMessage={<FormattedMessage {...messages.otpSentTo} />}
        failureMessage={
          responseError ? (
            <FormattedMessage {...messages.mobileResponseError} />
          ) : (
            ''
          )
        }
      />
      <CustomModal
        size="sm"
        title={<FormattedMessage {...messages.errorOtp} />}
        show={showCustomModal}
        onClose={() => setShowCustomModal(false)}
        message={<FormattedMessage {...messages.errorOtpContent} />}
      />

      {/* MODAL FOR CHOOSE AUTH METHOD */}
      <SecurityMethodsModal
        show={showMethodsModals}
        onClose={onClose}
        onChooseMethod={chooseMethodHandler}
        showMfa={showMfa}
        showQuest={showSec}
        showUigp={showUigp}
      />

      {/* UIGP OTP */}
      <ContactsModal
        show={showContactModal}
        onClose={closeContactModalHandler}
        onSelect={contactSelectHandler}
        isLogin={isLogin}
        isChangeMobile={operation === OtpOperationType.CHG_MOBILE_NUMBER}
        smsEnabled={smsEnabled}
      />
      <GenericOTPModal
        show={showUigpOtpModal}
        label={<FormattedMessage {...messages.otpLabel} />}
        modalTitle={<FormattedMessage {...messages.uigpOtpTitle} />}
        extraTxtContent={<FormattedMessage {...messages.otpSentTo} />}
        receiver={receiver}
        onClose={closeUigpOtpModalHandler}
        onConfirm={confirmUigpOtp}
      />

      {/* ARCOT OTP */}
      <OTPModal
        show={showMfaModal}
        onClose={closeMfaModalHandler}
        requireUserCode={isLogin}
        onConfirm={() => {
          isLogin && secAuthSuccessHandler()
        }}
        onConfirmOperation={(body: any) => {
          confirmOperation('mfaRequired', body)
        }}
        isLoginPage={isLogin}
      />

      {/* SEC QUESTIONS */}
      {/* NOT USED */}
      {isLogin && (
        <SecurityQuestionsModal
          show={showSecQuestModal}
          onClose={closeLoginSecQuestModalHandler}
          onConfirm={secAuthSuccessHandler}
          isLogin={isLogin}
        />
      )}
      {!isLogin && (
        <SecurityQuestionsUpdatePwdModal
          show={showSecQuestModal}
          onClose={closeSecQuestModalHandler}
          onConfirm={(body: any) => {
            setShowSecQuestModal(false)
            confirmOperation('securityQuestionsRequired', body)
          }}
          operation={
            operation === OtpOperationType.RESET_PWD
              ? MfaOperationType.RESET
              : operation === OtpOperationType.CHANGE_PWD
              ? MfaOperationType.CHANGE
              : operation === OtpOperationType.CHG_MOBILE_NUMBER
              ? MfaOperationType.MOBILE
              : null
          }
        />
      )}

      {/* CHANGE PWD MODAL */}
      {isLogin && (
        <PasswordModal
          show={showPasswordModal}
          onClose={() => {
            setFirstAccess(false)
            setOldPassword(null)
            setShowPasswordModal(false)
            setShowMethodsModal(!firstAccess && true)
          }}
          onConfirm={() => {
            onClose()
          }}
          isFirstAccess={firstAccess}
        />
      )}
    </>
  )
}

const mapStateToProps: any = (state: any) =>
  createStructuredSelector({
    callState: selectCallState,
    uigpOtpReceiver: selectUigpOtpReceiver,
    otpResponseState: responseOtpSelector,
    smsEnabled: selectSmsEnabled,
    responseError: selectAuthResponseError,
  })
const mapDispatchToProps: any = {
  generateUigpOTP: generateUigpOtpAction,
  verifyUigpOTP: verifyUigpOtpAction,
  postOtp: postOTPAction,
  setFirstAccess: setFirstAccessAction,
  setOldPassword: setOldPasswordAction,
}

const withConnect: any = connect(mapStateToProps, mapDispatchToProps)

export default withConnect(TwoFactorAuth)
